import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { DashboardService } from 'src/app/core/services/dashboard.service';
import { ToastService } from 'src/app/core/services/toast.service';

export interface Stat {
  title: string;
  icon: string;
  value: string;
}

export interface ChartType {
  series?: any;
  plotOptions?: any;
  stroke?: any;
  dataLabels?: any;
  chart?: any;
  legend?: any;
  colors?: any;
  labels?: any;
  tooltip?: any;
}

export interface Transaction {
  orderid: string;
  date: string;
  billingname: string;
  total: string;
  paymentstatus: string;
}

@Component({
    selector: 'app-e-sign-dashboard',
    templateUrl: './e-sign-dashboard.component.html',
    styleUrl: './e-sign-dashboard.component.scss',
    standalone: false
})
export class ESignDashboardComponent {

  statData: Stat[] = [];
  recentDocs: any = [];
  loading = false;
  salesAnalytics: ChartType = {};

  transactions: Transaction[] = [
    {
      orderid: '#NZ1563',
      date: '28 Mar, 2020',
      billingname: 'Frank Dean',
      total: '$164',
      paymentstatus: 'Unpaid'
    },
    {
      orderid: '#NZ1564',
      date: '28 Mar, 2020',
      billingname: 'Eddy Torres',
      total: '$141',
      paymentstatus: 'Paid'
    },
    {
      orderid: '#NZ1565',
      date: '29 Mar, 2020',
      billingname: 'Jamison Clark',
      total: '$123',
      paymentstatus: 'Paid'
    },
    {
      orderid: '#NZ1566',
      date: '30 Mar, 2020',
      billingname: 'Jewel Buckley',
      total: '$112',
      paymentstatus: 'Paid'
    },
    {
      orderid: '#NZ1567',
      date: '31 Mar, 2020',
      billingname: 'Jeffrey Waltz',
      total: '$105',
      paymentstatus: 'Unpaid'
    },
  ];

  term: any;
  monthlyData: any = [];
  months: any = [];
  selectedMonth: any;
  selectedYear = new Date().getFullYear();
  documentsCount: any = {}
  planInfo: any = {};
  stampStatusChart: ChartType = {};

  constructor(public formBuilder: UntypedFormBuilder, private dbs: DashboardService, private toastService: ToastService) {
  }


  ngOnInit(): void {
    const today = new Date();
    this.selectedMonth = {
      value: `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}`,
      label: `${today.toLocaleString('default', { month: 'short' })} - ${today.getFullYear()}`
    };

    this.getDashboard();
    this.getMontlyDocStatus();
    this.months = this.getPreviousSixMonthsWithLabel()
  }

  getDashboard() {
    this.loading = true;
    this.dbs.getDashboardData().subscribe((res: any) => {
      this.recentDocs = res.recentDocuments
      this.documentsCount = res.documentsCount;
      this.planInfo = res?.customer;
      this.loading = false;
    }, (err) => {
      this.loading = false;
    })
  }

  getPreviousSixMonthsWithLabel() {
    const result: { value: string; label: string }[] = [];
    const currentDate = new Date();

    for (let i = 5; i >= 0; i--) {
      const date = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - i,
        1
      );

      const year = date.getFullYear();
      const monthIndex = date.getMonth();

      const value = `${year}-${String(monthIndex + 1).padStart(2, '0')}`;
      const label = `${date.toLocaleString('default', { month: 'short' })} - ${year}`;

      result.push({ value, label });
    }

    return result;
  }

  getMontlyDocStatus() {
    if (!this.selectedMonth) {
      return;
    }

    const formattedDate = this.selectedMonth.value;

    this.dbs.getMonthlyDocStatus(formattedDate).subscribe(
      (res: any) => {
        this.monthlyData = res || [];

        const labels = this.monthlyData.map((item: any) => item?.status);
        const counts = this.monthlyData.map((item: any) => item?.count);

        this.salesAnalytics = {
          series: counts,
          chart: {
            height: 250,
            type: 'donut'
          },
          labels,
          plotOptions: {
            pie: {
              donut: {
                size: '70%'
              }
            }
          },
          tooltip: {
            y: {
              formatter: (value: number) => `${value}`
            }
          },
          dataLabels: {
            enabled: true
          },
          legend: {
            show: false
          },
          colors: ['#5664d2', '#1cbb8c', '#eeb902']
        };
      },
      () => {}
    );
  }


}



